// extracted by mini-css-extract-plugin
export default {"icon":"NotFound_icon__xAMnP"};